import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";

@Component({
    selector: "app-avatar",
    templateUrl: "./avatar.component.html",
    styleUrls: ["./avatar.component.scss"],
    standalone: true,
})
export class AvatarComponent implements OnInit, OnChanges {
    @Input() text = "";
    @Input() fontSize?: string;
    @Input() diameter?: string;

    public initials = "?";
    public backgroundColor = "#0f766e";
    public readonly defaultFontSize = "clamp(10px, 0.9vw, 14px)";
    public readonly defaultDiameter = "clamp(30px, 2.4vw, 44px)";

    private readonly colorPalette: string[] = [
        "#1d4ed8",
        "#0f766e",
        "#b91c1c",
        "#7c3aed",
        "#be185d",
        "#ca8a04",
        "#0891b2",
        "#15803d",
        "#334155",
        "#4338ca",
    ];

    ngOnInit(): void {
        this.backgroundColor = this.pickRandomColor();
        this.initials = this.getInitials(this.text);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["text"]) {
            this.initials = this.getInitials(this.text);
        }
    }

    public get resolvedFontSize(): string {
        return this.fontSize?.trim() || this.defaultFontSize;
    }

    public get resolvedDiameter(): string {
        return this.diameter?.trim() || this.defaultDiameter;
    }

    private getInitials(fullText: string): string {
        const parts = (fullText || "")
            .trim()
            .split(/\s+/)
            .filter(Boolean);

        if (!parts.length) {
            return "?";
        }

        if (parts.length === 1) {
            return parts[0].slice(0, 2).toUpperCase();
        }

        const first = parts[0][0];
        const last = parts[parts.length - 1][0];
        return `${first}${last}`.toUpperCase();
    }

    private pickRandomColor(): string {
        const randomIndex = Math.floor(Math.random() * this.colorPalette.length);
        return this.colorPalette[randomIndex];
    }
}
